module.exports = __webpack_public_path__ + "img/e3.d40265fd.png";